import * as React from "react";
import LargeHeroArea from "../components/shared/BasePage/LargeHeroArea";
import BasePageStyles from "../components/shared/Styling/BasePageStyling";
import { useAuth } from "../services/authentication";
import TracercoButton from "../components/shared/TracercoButton";
import HeroImage from "../assets/headers/DrillingRigCompressed.jpg";
import { Redirect, useLocation } from "react-router-dom";
import DemoRequestForm from "../components/DemoRequestForm";
import { Container, Grid, Typography } from "@material-ui/core";
import YouTube from "react-youtube";
import { useTranslation } from "react-i18next";
import { ROUTE_PATH_HOME, ROUTE_PATH_PROJECTS } from "../routes";
import SimpleTabs from "../components/shared/BasePage/CaseStudies";

const LoginPage: React.FC = () => {
    const classes = BasePageStyles();
    const { authState, login } = useAuth();
    const { t } = useTranslation();
    const location = useLocation();

    //// if the user is already logged in we want to redirect them away from the login page.
    if (authState.loggedIn) {
        //// by default we will take them to the list of projects.
        let redirectTo = ROUTE_PATH_PROJECTS;

        //// if there is already a path set (which is not the login page), use that instead.
        if (location.pathname !== ROUTE_PATH_HOME) {
            redirectTo = location.pathname;
        }

        return <Redirect to={redirectTo} />;
    }

    return (
        <div id="login-page-content">
            <main className={classes.main}>
                <LargeHeroArea
                    imageUri={HeroImage}
                    title="Welcome to a world of insight"
                    subtitle="Tracerco's Insights Platform is the secure way to access, interpret, track and customise all of your reservoir project data, wherever you are in the world."
                >
                    <TracercoButton
                        variant="contained"
                        onClick={async () => {
                            await login();
                        }}
                        color="inherit"
                        className={classes.loginButton}
                    >
                        Login
                    </TracercoButton>
                </LargeHeroArea>

                <section className={classes.demoSection} id="request-demo">
                    <Container>
                        <Typography
                            variant="h4"
                            align="center"
                            className={classes.demoH4}
                        >
                            {t("demo-request-title")}
                        </Typography>
                        <Grid container spacing={10} direction="row">
                            <Grid item xs={12} sm={5} md={6} lg={6} xl={6}>
                                <DemoRequestForm />
                            </Grid>
                            <Grid item xs={12} sm={7} md={6} lg={6} xl={6}>
                                <div
                                    style={{
                                        position: "relative",
                                        left: "50%",
                                        top: "50%",
                                        transform: "translate(-50%, -50%)"
                                    }}
                                >
                                    <YouTube
                                        containerClassName={"youtubeContainer"}
                                        videoId={t("demo-request-video-id")}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </section>
                <section style={{ paddingTop: "80px" }} id="case-study">
                    <SimpleTabs></SimpleTabs>
                </section>
            </main>
        </div>
    );
};

export default LoginPage;
